<template lang="pug">
md-input-container(:class='{ "md-input-invalid" : showRequiredError }')
  label {{ multiple ? 'Networks' : 'Network' }}
  md-select(name='network', :multiple='multiple', v-model='selected', @selected='onNetworkSelected', :disabled='networks.length === 0')
    md-option(v-for='network in networks', :value='network._id', :key='network._id') {{ network.name }}
  span.md-error(v-show='showRequiredError') This field is required
</template>

<script>
  import networkService from '../../services/networkService';

  export default {
    props: {
      value: {
        type: [String, Array]
      },
      multiple: {
        type: Boolean,
        default: false
      },
      showRequiredError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selected: this.value,
        networks: []
      };
    },
    methods: {
      onNetworkSelected(value) {
        this.$emit('input', value);
      }
    },
    mounted() {
      const params = { limit: 100, sortBy: 'name', sortOrder: 'asc', status: 'public' };
      networkService.getList(params)
        .then((response) => {
          this.networks = response.data.networks;
        })
        .catch(() => {
          this.$emit('getNetworksError');
        });
    },
    watch: {
      value(newValue) {
        this.selected = newValue;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/network/NetworkSelector.vue